import { useState, useEffect } from "react";
import { ticketsApi } from "../../utils/api";

export default function AdminDashboard() {
  const [tab, setTab]       = useState("overview");
  const [stats, setStats]   = useState(null);
  const [events, setEvents] = useState([]);
  const [orders, setOrders] = useState([]);
  const [orgs, setOrgs]     = useState([]);

  useEffect(() => {
    ticketsApi.adminOverview().then(d => setStats(d)).catch(()=>{});
  }, []);

  useEffect(() => {
    if (tab==="events")      ticketsApi.adminEvents().then(d=>setEvents(d.events||[])).catch(()=>{});
    if (tab==="orders")      ticketsApi.adminOrders().then(d=>setOrders(d.orders||[])).catch(()=>{});
    if (tab==="organisers")  ticketsApi.adminOrganisers().then(d=>setOrgs(d.organisers||[])).catch(()=>{});
  }, [tab]);

  const s = stats?.stats || {};

  return (
    <div className="min-h-screen p-6" style={{background:"#050508"}}>
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="font-display text-2xl font-bold text-white">Ticket Platform Dashboard</h1>
            <p className="text-gray-500 text-sm">NagNail Tickets — Admin Overview</p>
          </div>
          <button onClick={()=>window.open("/","_self")} className="text-xs glass px-4 py-2 rounded-lg text-gray-300 hover:text-white transition">← Public site</button>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          {[
            {l:"Total Revenue",    v:`LKR ${((s.totalRevenue||0)/1000).toFixed(0)}K`, c:"brand"},
            {l:"Tickets Sold",     v:(s.totalTickets||0).toLocaleString(),            c:"blue"},
            {l:"Live Events",      v:s.onSaleEvents||0,                               c:"green"},
            {l:"Organisers",       v:s.totalOrganisers||0,                            c:"gold"},
          ].map(x=>(
            <div key={x.l} className="glass rounded-2xl p-5">
              <p className="text-xs text-gray-400 mb-1">{x.l}</p>
              <p className="text-2xl font-bold text-white">{x.v}</p>
            </div>
          ))}
        </div>

        <div className="flex gap-1 mb-6 glass rounded-xl p-1 w-fit">
          {["overview","events","orders","organisers"].map(t=>(
            <button key={t} onClick={()=>setTab(t)}
              className={`px-4 py-2 rounded-lg text-sm font-medium capitalize transition ${tab===t?"bg-brand-700 text-white":"text-gray-400 hover:text-white"}`}>
              {t}
            </button>
          ))}
        </div>

        {tab==="overview" && stats && (
          <div className="grid lg:grid-cols-2 gap-6">
            <div className="glass rounded-2xl p-5">
              <h2 className="font-semibold text-white mb-4">Recent Orders</h2>
              <div className="space-y-3">
                {(stats.recentOrders||[]).map(o=>(
                  <div key={o.order_ref} className="flex items-center justify-between py-2 border-b border-white/5 last:border-0">
                    <div>
                      <p className="text-white text-xs font-mono">{o.order_ref}</p>
                      <p className="text-gray-500 text-xs">{o.event_title} · {o.tier_name}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-white text-xs font-semibold">LKR {parseInt(o.total).toLocaleString()}</p>
                      <span className={`text-xs px-2 py-0.5 rounded-full ${o.status==="confirmed"?"bg-green-900/50 text-green-300":"bg-yellow-900/50 text-yellow-300"}`}>{o.status}</span>
                    </div>
                  </div>
                ))}
                {!stats.recentOrders?.length && <p className="text-gray-500 text-sm text-center py-4">No orders yet</p>}
              </div>
            </div>
            <div className="glass rounded-2xl p-5">
              <h2 className="font-semibold text-white mb-4">Revenue by Category</h2>
              <div className="space-y-3">
                {(stats.revenueByCategory||[]).map(c=>(
                  <div key={c.category}>
                    <div className="flex justify-between text-xs mb-1"><span className="text-gray-400">{c.category}</span><span className="text-white">LKR {parseInt(c.revenue).toLocaleString()}</span></div>
                    <div className="h-1.5 bg-white/10 rounded-full"><div className="h-full rounded-full bg-brand-500" style={{width:`${Math.min(100,parseInt(c.revenue)/Math.max(...(stats.revenueByCategory||[{revenue:1}]).map(x=>parseInt(x.revenue)))*100)}%`}}/></div>
                  </div>
                ))}
                {!stats.revenueByCategory?.length && <p className="text-gray-500 text-sm text-center py-4">No revenue data yet</p>}
              </div>
            </div>
          </div>
        )}

        {tab==="events" && (
          <div className="glass rounded-2xl p-5">
            <h2 className="font-semibold text-white mb-4">All Events</h2>
            <table className="w-full text-sm">
              <thead><tr className="text-left text-gray-500 text-xs border-b border-white/10">
                <th className="pb-3">Event</th><th className="pb-3">Date</th><th className="pb-3">Tickets</th><th className="pb-3">Revenue</th><th className="pb-3">Status</th><th className="pb-3">Actions</th>
              </tr></thead>
              <tbody className="divide-y divide-white/5">
                {events.map(e=>{
                  const sold=parseInt(e.total_sold)||0; const cap=parseInt(e.total_capacity)||1;
                  return (
                    <tr key={e.id} className="hover:bg-white/2 transition">
                      <td className="py-3"><p className="text-white text-xs font-medium">{e.title}</p><p className="text-gray-500 text-xs">{e.organiser_name}</p></td>
                      <td className="py-3 text-gray-400 text-xs">{e.event_date}</td>
                      <td className="py-3"><p className="text-white text-xs">{sold}/{cap}</p><div className="w-16 h-1 bg-white/10 rounded-full mt-1"><div className="h-full rounded-full bg-brand-500" style={{width:`${Math.round(sold/cap*100)}%`}}/></div></td>
                      <td className="py-3 text-white text-xs">LKR {((parseInt(e.revenue)||0)/1000).toFixed(0)}K</td>
                      <td className="py-3"><span className={`text-xs px-2 py-0.5 rounded-full ${e.status==="on_sale"?"bg-green-900/50 text-green-300":"bg-gray-800 text-gray-400"}`}>{e.status}</span></td>
                      <td className="py-3">
                        <select onChange={ev=>ticketsApi.updateEvent(e.id,{status:ev.target.value}).then(()=>ticketsApi.adminEvents().then(d=>setEvents(d.events||[])))}
                          defaultValue={e.status} className="text-xs bg-gray-800 text-gray-300 rounded px-2 py-1 border border-white/10">
                          {["draft","on_sale","paused","ended","cancelled"].map(s=><option key={s} value={s}>{s}</option>)}
                        </select>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {!events.length && <p className="text-gray-500 text-sm text-center py-8">No events yet</p>}
          </div>
        )}

        {tab==="orders" && (
          <div className="glass rounded-2xl p-5">
            <h2 className="font-semibold text-white mb-4">All Orders</h2>
            <table className="w-full text-sm">
              <thead><tr className="text-left text-gray-500 text-xs border-b border-white/10">
                <th className="pb-3">Order</th><th className="pb-3">Customer</th><th className="pb-3">Event</th><th className="pb-3">Total</th><th className="pb-3">Status</th>
              </tr></thead>
              <tbody className="divide-y divide-white/5">
                {orders.map(o=>(
                  <tr key={o.id} className="hover:bg-white/2 transition">
                    <td className="py-3 text-brand-300 text-xs font-mono">{o.order_ref}</td>
                    <td className="py-3"><p className="text-white text-xs">{o.primary_attendee}</p><p className="text-gray-500 text-xs">{o.primary_email}</p></td>
                    <td className="py-3"><p className="text-white text-xs">{o.event_title}</p><p className="text-gray-500 text-xs">{o.tier_name} ×{o.quantity}</p></td>
                    <td className="py-3 text-white text-xs font-semibold">LKR {parseInt(o.total).toLocaleString()}</td>
                    <td className="py-3"><span className={`text-xs px-2 py-0.5 rounded-full ${o.status==="confirmed"?"bg-green-900/50 text-green-300":o.status==="pending"?"bg-yellow-900/50 text-yellow-300":"bg-red-900/50 text-red-300"}`}>{o.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!orders.length && <p className="text-gray-500 text-sm text-center py-8">No orders yet</p>}
          </div>
        )}

        {tab==="organisers" && (
          <div className="glass rounded-2xl p-5">
            <h2 className="font-semibold text-white mb-4">Organisers</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {orgs.map(o=>(
                <div key={o.id} className="border border-white/10 rounded-xl p-4">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 rounded-lg bg-brand-800 flex items-center justify-center text-sm font-bold text-brand-200">{o.name[0]}</div>
                    <div><p className="text-white text-sm font-medium">{o.name}</p><p className={`text-xs ${o.approved?"text-green-400":"text-yellow-400"}`}>{o.approved?"✓ Approved":"⏳ Pending"}</p></div>
                  </div>
                  <p className="text-gray-500 text-xs mb-3">{o.email}</p>
                  {!o.approved && (
                    <button onClick={()=>ticketsApi.approveOrg(o.id,{approved:true}).then(()=>ticketsApi.adminOrganisers().then(d=>setOrgs(d.organisers||[])))}
                      className="w-full text-xs bg-brand-700 hover:bg-brand-600 py-1.5 rounded-lg text-white transition">
                      Approve
                    </button>
                  )}
                </div>
              ))}
              {!orgs.length && <p className="text-gray-500 text-sm col-span-3 text-center py-8">No organisers yet</p>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}